export default "__VITE_ASSET__C_hz6ZjA__"